import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';

export const AdminCanvasCoursesPage = () => {
  return (
    <>
      <Helmet>
        <title>Canvas Courses - AutoScript Admin</title>
      </Helmet>
      <Header title={'Canvas Courses'} />

      <Content />
    </>
  );
};
